import { ResponseMessageWithInternalStatus } from "../dto/response-message-with-internal-status.dto";

export interface TipoDocumento {
  id: number;
  denominacion: string;
  codigoAfip: number;
}

export interface TipoDocumentos {
    tipoDocumentos: TipoDocumento[];
}

export interface ObtenerListadoTipoDocumentoResponse extends ResponseMessageWithInternalStatus{
  tiposDocumento: {
    id: number;
    denominacion: string;
    codigoAfip: number;
  }[];
}

export interface TipoDocumentosState {
  tipoDocumentos: TipoDocumento[];
  error: boolean;
  debugMessage?: any;
}

export const initialTipoDocumentosState: TipoDocumentosState = {
  tipoDocumentos: [],
  error: false,
  debugMessage: null
};
